import { storyPoints, storyTags } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function StoryIntro() {
  return (
    <section id="story" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <SectionHeading
          eyebrow="作品背景"
          title="先弄清它是什么，再决定怎么看"
          desc="《漂亮的小姨子》属于都市家庭情感方向的连载题材，下面这几条能帮你在进入具体分区之前，先建立一个整体印象。"
        />

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-10 items-start">
          <div className="relative rounded-lg overflow-hidden w-full h-[280px] md:h-[420px]">
            <img
              src="https://readdy.ai/api/search-image?query=Cozy%20warm%20reading%20nook%20styled%20as%20an%20artistic%20still%20life%2C%20stacked%20vintage%20books%20with%20deep%20red%20and%20gold%20spines%2C%20a%20small%20vase%20of%20roses%2C%20soft%20amber%20lamp%20glow%2C%20rich%20cream%20and%20burgundy%20palette%2C%20painterly%20textured%20illustration%2C%20calm%20nostalgic%20mood&width=1000&height=1200&seq=plxdz-story-cover&orientation=portrait"
              alt="暖色调的阅读角落插画，摆放着旧书与玫瑰"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute bottom-4 left-4 right-4 rounded-md bg-background-50/90 backdrop-blur px-4 py-3">
              <p className="text-sm text-foreground-700">
                题材标签以整理归类为目的，具体设定请以对应来源的实际内容为准。
              </p>
            </div>
          </div>

          <div>
            <div className="flex flex-wrap gap-2">
              {storyTags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 text-xs md:text-sm rounded-full bg-secondary-100 text-secondary-900 border border-secondary-200 whitespace-nowrap"
                >
                  #{tag}
                </span>
              ))}
            </div>

            <div className="mt-6 space-y-4">
              {storyPoints.map((point) => (
                <div
                  key={point.title}
                  className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
                >
                  <span className="shrink-0 w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 text-accent-800 text-lg">
                    <i className={point.icon}></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                      {point.title}
                    </h3>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">{point.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}